<template>
    <v-btn 
        outlined
        class="light-blue-button"
        color="primary darken-1"
        @click="resetPass()">
        Reset User's Password
    </v-btn>
</template>

<script>  
    import axios from "axios"
    import appUrls from '../../helpers/environment'

    export default {
        name: 'resetPasswordButton',

        props: {
            userData: Object,
            userFeedback: Function
        },

        methods: {
            resetPass: async function () {
                try {
                    if (confirm("Are you sure you want to reset the user's password?")) {
                        const reset_password = await axios.post(`${appUrls.api}/api/resetpw`, {
                            headers: { "content-type": "application/json" },
                            email_address: this.userData.user_email,
                            source: 'admin'
                        })

                        if (reset_password.data.outcome) {
                            this.$feedback.success( reset_password.data.message );
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<style scoped>
    .light-blue-button {
        background-color: #eef7f8;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/resetPassword.vue